import { api, unwrapData } from '../../../app/store/api';
import { Wallet } from 'features/profile/types/wallet.types';

export const walletApi = api.injectEndpoints({
    endpoints: (build) => ({
        wallets: build.query<Wallet[], { search?: object }>({
            transformResponse: unwrapData,
            query: ({ search }) => ({
                url: 'user/me/wallets',
                method: 'GET',
                params: {
                    ...search,
                },
            }),
        }),
        chargeWallet: build.mutation<
            { pay_url: string },
            { id: number; amount: number }
        >({
            transformResponse: unwrapData,
            query: (body) => ({
                url: 'user/me/wallets/charge',
                method: 'POST',
                body,
            }),
        }),
        walletTransaction: build.query<
            { items: any[]; pagination: any },
            { id: number; page?: number; perPage?: number }
        >({
            transformResponse: unwrapData,
            query: ({ id, page, perPage = 15 }) => ({
                url: 'user/me/wallets/transactions',
                method: 'GET',
                params: {
                    wallet_id: id,
                    ...(page && { page }),
                    ...(perPage && { per_page: perPage }),
                },
            }),
        }),
    }),
});

export const {
    useWalletsQuery,
    useChargeWalletMutation,
    useWalletTransactionQuery,
} = walletApi;
